import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'components/graphql'
import {
	rawCreateProject,
	rawDeleteProject
} from 'sections/options/sections/RestaurantDesigner/mutations'
import { StyledProjectControls } from './styled'
import { RestaurantContext } from 'sections/options/sections/RestaurantDesigner/RestaurantDesignerHandler'
import { ConfirmModal } from 'components/Modal'
import ItemActions from 'components/SectionHandler/ItemActions/ItemActions'
import { mutation } from '../../helpers'

import { ReactComponent as NewProject } from './icons/new-project.svg'
import { ReactComponent as DeleteProject } from './icons/delete-project.svg'

const ProjectControls = (props) => {
	const [t] = useTranslation()
	const { currentProjectIds, setCurrentProjectIds } = useContext(RestaurantContext)
	const [createProject] = useMutation(rawCreateProject)
	const [deleteProject] = useMutation(rawDeleteProject)

	const handleCreateProject = () => mutation(createProject, {
		defaultRoomCaption: t('restaurant_designer_section.strings.default_room_name'),
		caption: t('restaurant_designer_section.strings.default_project_name')
	})
		.then((response)=>{
			const newProject = response.data.cashAssist.createProject
			setCurrentProjectIds({ projectId: newProject.id })
		})
	const handleDeleteProject = id => ConfirmModal({
		show: true,
		label: t('common.buttons.confirm'),
		text: t('restaurant_designer_section.strings.want_remove_project')
	})
		.then(
			confirmed => {
				mutation(deleteProject, { id })
					.then(() => setCurrentProjectIds({ projectId: null, floorId: null, roomId: null }))
			},
			rejected => null
		)

	return (
		<StyledProjectControls>
			<ItemActions
				actions={[
					{ label: t('restaurant_designer_section.fields.project_create'), Icon: NewProject, action: handleCreateProject },
					{ additionalStyles: `
						color: red;
					`,
					label: t('restaurant_designer_section.fields.project_delete'), Icon: DeleteProject, action: ()=> handleDeleteProject(currentProjectIds.projectId), checkAvailability: (item)=> item }]}
				item={currentProjectIds.projectId}
			/>
		</StyledProjectControls>

	)
}

export default ProjectControls
